export default __webpack_public_path__ + "static/media/token_economy.acf29fe4.png";